export const restrictedFilespacePredicate = (filespaceData) => {
    return filespaceData.settings.restrictWebAccess;
};
